/** Fixed text for the staff Family Portal tab (Phase 12, FAM-06). */
import type { LegalAuthorityCode, PortalInviteStatus, PortalUserStatus } from '../../../dtos/portal/familyPortalAdmin.dto';

/** What an approved guardian can read in the portal (the FAM-06 allow-list). */
export const GUARDIAN_WILL_SEE: readonly string[] = [
  'Upcoming visits for the next 14 days: date, time window, discipline, and the clinician’s first name and credential',
  'Visit summaries written by clinicians',
  'The current completed care plan',
  'Medications (current and past)',
  'Growth measurements and percentiles',
  'Care team: first name, credential and discipline',
  'About the patient: name, date of birth, sex, allergies, guardians, primary care provider and photo',
  'The agency’s phone number, email and office hours',
];

/** What a guardian never sees. */
export const GUARDIAN_NEVER_SEES: readonly string[] = [
  'Insurance, Medicaid ID and other identifiers',
  'Prior authorizations, billing and claims',
  'Clinical notes beyond the visit summary: vitals, MAR, assessments, incidents',
  'Forms, signed documents and the plan of care (CMS-485)',
  'Staff email addresses, phone numbers and full names',
  'Addresses, visit notes and EVV records',
  'Any other patient',
];

export const LEGAL_AUTHORITY_LABELS: Record<LegalAuthorityCode, string> = {
  PARENT: 'Parent',
  LEGAL_GUARDIAN: 'Legal guardian',
  CONSERVATOR: 'Conservator',
  OTHER: 'Other',
};

export const LEGAL_AUTHORITY_CODES: readonly LegalAuthorityCode[] = ['PARENT', 'LEGAL_GUARDIAN', 'CONSERVATOR', 'OTHER'];

export function isLegalAuthorityCode(value: string | null | undefined): value is LegalAuthorityCode {
  return !!value && (LEGAL_AUTHORITY_CODES as readonly string[]).includes(value);
}

export function legalAuthorityLabel(value: string | null | undefined): string {
  if (!value) return '—';
  return isLegalAuthorityCode(value) ? LEGAL_AUTHORITY_LABELS[value] : value;
}

export const INVITE_STATUS_LABELS: Record<PortalInviteStatus, string> = {
  PENDING: 'Invite sent',
  USED: 'Invite accepted',
  EXPIRED: 'Invite expired',
  LOCKED: 'Invite locked',
  CANCELLED: 'Invite cancelled',
};

export const PORTAL_USER_STATUS_LABELS: Record<PortalUserStatus, string> = {
  PENDING_APPROVAL: 'Awaiting approval',
  ACTIVE: 'Active',
  REVOKED: 'Revoked',
  ENDED: 'Ended',
};

export const STATUS_CLASSES: Record<string, string> = {
  PENDING: 'bg-amber-100 text-amber-900 border-amber-300',
  PENDING_APPROVAL: 'bg-amber-100 text-amber-900 border-amber-300',
  LOCKED: 'bg-red-100 text-red-900 border-red-300',
  ACTIVE: 'bg-emerald-100 text-emerald-900 border-emerald-300',
  USED: 'bg-emerald-100 text-emerald-900 border-emerald-300',
  REVOKED: 'bg-slate-100 text-slate-800 border-slate-300',
  ENDED: 'bg-slate-100 text-slate-800 border-slate-300',
  EXPIRED: 'bg-slate-100 text-slate-800 border-slate-300',
  CANCELLED: 'bg-slate-100 text-slate-800 border-slate-300',
};
